module.exports = __webpack_public_path__ + "img/Monte_Kope_5.85a65a4b.jpg";